import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import { Flex, Spinner, Text } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { memo, useEffect, useState } from "react";
import { ExternalService } from "../../services/ExternalService";
import CustomAudioRenderer from "./CustomAudioRenderer";
import CustomDocumentRenderer from "./CustomDocumentRenderer";
import CustomDownloadRenderer from "./CustomDownloadRenderer";
import CustomHeader from "./CustomHeader";
import CustomLoader from "./CustomLoader";
import CustomVideoRenderer from "./CustomVideoRenderer";
import "./DocViewer.css";

const DocumentViewer = memo(
  ({
    selectedStudent,
    isJA,
    assessmentId,
    fetchEvidence,
    setFetchEvidence,
  }) => {
    const { t } = useTranslation();
    const [documents, setDocuments] = useState(null);

    useEffect(() => {
      if (selectedStudent || fetchEvidence) {
        setFetchEvidence(false);
        setDocuments(null);
        if (isJA) {
          const file = selectedStudent.attachments[0];
          const fileType = file.name.split(".").pop().toLowerCase();
          setDocuments([
            {
              uri: file.url,
              fileType: fileType,
              fileName: `student_${selectedStudent.index}_evidence.${fileType}`,
            },
          ]);
        } else {
          const id = selectedStudent.canvas_id;
          ExternalService.requestDownload(
            "evidence",
            assessmentId + "/" + id
          ).then((files) => {
            setDocuments(
              files.map((file) => ({
                uri: file.file_url,
                fileType: file.file_name.split(".").pop().toLowerCase(),
                fileName: file.file_name,
              }))
            );
          });
        }
      }
    }, [selectedStudent, assessmentId, isJA, fetchEvidence]);

    return !documents ? (
      <Flex height="30rem" justifyItems="center">
        <Flex.Item textAlign="center">
          <Spinner
            renderTitle={t("documentViewer.loadingEvidence")}
            size="large"
            delay={1500}
          />
        </Flex.Item>
      </Flex>
    ) : documents.length === 0 ? (
      <Flex height="30rem" justifyItems="center">
        <Flex.Item textAlign="center">
          <Text size="x-large">{t("evidence.noEvidence")}</Text>
        </Flex.Item>
      </Flex>
    ) : (
      <DocViewer
        pluginRenderers={[
          ...DocViewerRenderers,
          CustomDocumentRenderer,
          CustomAudioRenderer,
          CustomVideoRenderer,
          CustomDownloadRenderer,
        ]}
        documents={documents}
        config={{
          header: { overrideComponent: CustomHeader },
          loadingRenderer: { overrideComponent: CustomLoader },
        }}
      />
    );
  }
);

export default DocumentViewer;
